/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FxIdWebFeaturesPlayListResponseBuild } from './FxIdWebFeaturesPlayListResponseBuild';
import {
    FxIdWebFeaturesPlayListResponseBuildFromJSON,
    FxIdWebFeaturesPlayListResponseBuildFromJSONTyped,
    FxIdWebFeaturesPlayListResponseBuildToJSON,
    FxIdWebFeaturesPlayListResponseBuildToJSONTyped,
} from './FxIdWebFeaturesPlayListResponseBuild';

/**
 * 
 * @export
 * @interface FxIdWebFeaturesPlayListResponse
 */
export interface FxIdWebFeaturesPlayListResponse {
    /**
     * 
     * @type {Array<FxIdWebFeaturesPlayListResponseBuild>}
     * @memberof FxIdWebFeaturesPlayListResponse
     */
    Builds: Array<FxIdWebFeaturesPlayListResponseBuild>;
}

/**
 * Check if a given object implements the FxIdWebFeaturesPlayListResponse interface.
 */
export function instanceOfFxIdWebFeaturesPlayListResponse(value: object): value is FxIdWebFeaturesPlayListResponse {
    if (!('Builds' in value) || value['Builds'] === undefined) return false;
    return true;
}

export function FxIdWebFeaturesPlayListResponseFromJSON(json: any): FxIdWebFeaturesPlayListResponse {
    return FxIdWebFeaturesPlayListResponseFromJSONTyped(json, false);
}

export function FxIdWebFeaturesPlayListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdWebFeaturesPlayListResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'Builds': ((json['Builds'] as Array<any>).map(FxIdWebFeaturesPlayListResponseBuildFromJSON)),
    };
}

export function FxIdWebFeaturesPlayListResponseToJSON(json: any): FxIdWebFeaturesPlayListResponse {
    return FxIdWebFeaturesPlayListResponseToJSONTyped(json, false);
}

export function FxIdWebFeaturesPlayListResponseToJSONTyped(value?: FxIdWebFeaturesPlayListResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'Builds': ((value['Builds'] as Array<any>).map(FxIdWebFeaturesPlayListResponseBuildToJSON)),
    };
}

